import { RegistroPagoPendienteOutput } from "src/gql/schema"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { formatCurrency } from "src/shared/hooks/formatCurrency"
import FlexibleTable from "src/shared/components/data-display/FlexibleTable/FlexibleTable"
import "./TablaPagosPendientes.css"

export interface TablaPagosPendientesProps {
    registros: RegistroPagoPendienteOutput[]
}

const headers = [
    { value: "#" },
    { value: "Categoría" },
    { value: "Concepto" },
    { value: "Monto" },
    { value: "Fecha" },
]

function TablaPagosPendientes({ registros }: TablaPagosPendientesProps): JSX.Element {
    const { formatCustomDate } = useFormatDate()

    registros
        .filter((registro) => registro.categoria?.toLowerCase() === "rs")
        .forEach((registro) => console.log("registro rs", registro))

    const rows = registros.map((registro, idx) => ({
        key: `${registro.folio}-${registro.categoria}-${idx}`,
        value: [
            { value: registro.folio },
            { value: registro.categoria },
            { value: registro.concepto?.replace(/\//g, "") },
            { value: formatCurrency(registro.monto) },
            { value: formatCustomDate(registro.fecha, "DD/MMM/YY h:mm A") },
        ],
    }))

    return (
        <div className="tabla-pagos-pendientes__container">
            <FlexibleTable tableItems={{ headers, rows }} />
        </div>
    )
}

export default TablaPagosPendientes
